import { message } from 'antd';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { transport } from '../../../utils/constants';
import { getToken, haptic, Haptick } from '../../../utils/helper';
import { BinaryClient } from '../../../generated/mlmbox/client/binary/binary.client';
import Button from '../../../components/Button/Button';

export const SettingBinary: FC<{ openSetting: Function; branchSelectStrategy: number; positionId: number }> = ({
    branchSelectStrategy,
    positionId,
    openSetting,
}) => {
    const [loadBinary] = useState(false);
    const [tab, setTab] = useState<number>(branchSelectStrategy);
    const { t } = useTranslation();
    function setCategory(id: number) {
        if (loadBinary) return;

        const binaryClient = new BinaryClient(transport);

        binaryClient
            .setPositionBranchSelectStrategy(
                {
                    branchSelectStrategyId: id,
                    positionId: positionId,
                },
                { meta: { authorization: getToken() } }
            )
            .then(() => message.success(t('success.bin')));
    }
    return (
        <div className="setting-binary">
            <p>{t('change.branch')}</p>
            <div
                className="setting-binary__tabs"
                style={{ opacity: loadBinary ? '0.5' : '1' }}>
                <button
                    onClick={() => {
                        if (loadBinary || tab === 1) return;
                        setTab(1);
                        setCategory(1);
                        Haptick(haptic.light);
                        openSetting(true);
                    }}
                    className={`green tab ${tab === 1 ? 'active' : ''}`}>
                    {t('left')}
                </button>
                <button
                    onClick={() => {
                        if (loadBinary || tab === 3) return;
                        setTab(3);
                        setCategory(3);
                        Haptick(haptic.light);
                        openSetting(true);
                    }}
                    className={`blue tab ${tab === 3 ? 'active' : ''}`}>
                    {t('evenly')}
                </button>
                <button
                    onClick={() => {
                        if (loadBinary || tab === 2) return;
                        setTab(2);
                        setCategory(2);
                        Haptick(haptic.light);
                        openSetting(true);
                    }}
                    className={`blue tab ${tab === 2 ? 'active' : ''}`}>
                    {t('right')}
                </button>
            </div>
        </div>
    );
};
